/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_HeadingInputs */

const tr_mesafeli_s10_heading = /** @type {(inputs: Mesafeli_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Pazaryeri API Erişim Bilgilerinin Saklanması`)
};

const en_mesafeli_s10_heading = /** @type {(inputs: Mesafeli_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Storage of Marketplace API Access Credentials`)
};

const de_mesafeli_s10_heading = /** @type {(inputs: Mesafeli_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Speicherung der Marktplatz-API-Zugangsdaten`)
};

const ru_mesafeli_s10_heading = /** @type {(inputs: Mesafeli_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Хранение данных доступа к API маркетплейсов`)
};

/**
* | output |
* | --- |
* | "10. Storage of Marketplace API Access Credentials" |
*
* @param {Mesafeli_S10_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_heading = /** @type {((inputs?: Mesafeli_S10_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_heading(inputs)
	if (locale === "de") return de_mesafeli_s10_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s10_heading(inputs)
	return tr_mesafeli_s10_heading(inputs)
});